import React from 'react'
import { withStyles } from '@material-ui/core'
import { Input } from 'Components/Form'

const styles = {
  wrapper: {
    position: 'relative',
    width: '180px',
    paddingRight: '16px',
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
  },
  prefix: {
    position: 'absolute',
    left: '12px',
    bottom: '16px',
    color: '#546B81',
    fontSize: '14px',
    pointerEvents: 'none',
    letterSpacing: '-0.154px',
    zIndex: 1,
  },
  suffix: {
    position: 'absolute',
    right: '28px',
    bottom: '16px',
    color: '#546B81',
    fontSize: '14px',
    pointerEvents: 'none',
    letterSpacing: '-0.154px',
  },
}

const BudgetInput = ({ classes, suffix, ...inputProps }) => {
  const inputStyle =
    inputProps.input && inputProps.input.style
      ? { paddingLeft: '24px', ...inputProps.input.style }
      : { paddingLeft: '24px' }

  return (
    <div className={classes.wrapper}>
      <span className={classes.prefix}>$</span>
      <Input
        {...inputProps}
        input={{
          ...inputProps.input,
          min: 0,
          style: inputStyle,
        }}
      />
      {suffix && <span className={classes.suffix}>{suffix}</span>}
    </div>
  )
}

export default withStyles(styles)(BudgetInput)
